// Angular
import { Component } from '@angular/core';
import { CartService } from '@app/views/pages/transpop/cart1/cart.service';
import { AppSessionService } from '@shared/session/app-session.service';

@Component({
	selector: 'kt-topbar',
	templateUrl: './topbar.component.html',
	styleUrls: ['./topbar.component.scss'],
})
export class TopbarComponent { 

	constructor(
		public cartService: CartService,
		public appSessionService: AppSessionService
	){

	}

}
